import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

import moment from 'moment';
import 'moment/locale/es';

// Angular: pipes de data, etc.
registerLocaleData(localeEs);

// Moment: que faci servir el locale 'es'
moment.locale('es');

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
